import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimUserExtendedService, SimUtilityService} from "@services";
import {Router} from "@angular/router";
import {Translations} from "@translations";

export interface DialogData_PowerOffDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_PowerOffDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-power-off-dialog",
	templateUrl: "./power-off-dialog.component.html",
	styleUrls: ["./power-off-dialog.component.scss"],
	standalone: false,
})
export class PowerOffDialogComponent extends BasicMaterialDialog<
	PowerOffDialogComponent,
	DialogData_PowerOffDialogInput,
	DialogData_PowerOffDialogOutput
> {
	T = Translations;
	SimUtilityService = SimUtilityService;

	constructor(
		_injector: Injector,
		private _simUserService: SimUserExtendedService,
		private _router: Router,
	) {
		super(_injector);
	}

	ngOnInit(): void {}

	logOut() {
		this.close({action: "close"});
		this._router.navigate(["login"], {queryParams: {logout: true}});
		/*
		this._simUserService.logout().then(() => {
			this.close({action: 'close'});
			this._router.navigate(["login"], {queryParams: { logout: true}});
		});*/
	}

	exit() {
		window.close();
	}
}
